import { loadStripe } from '@stripe/stripe-js';
import type { Appearance } from '@stripe/stripe-js';

/**
 * Stripe public API key (test key)
 */
const STRIPE_PUBLIC_API_KEY = window.stripePublishableKey;

const API_ENDPOINT_CREATE_SPONSORSHIP = '/api/payment/createsponsorship';

const URL_SPONSORSHIP_SUCCESS = '/events/sponsorship-success';

/**
 * Stripe element custom styles
 */
const stripeElementStyles = {
    base: {
        fontWeight: '400',
        fontFamily:
            '"URWDIN",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans","Liberation Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
        fontSize: '16px',
        fontSmoothing: 'antialiased',
        '::placeholder': {
            color: '#6c757d',
        },
    },
    invalid: {
        iconColor: 'rgb(220, 53, 69)',
        color: 'rgb(220, 53, 69)',
    },
};

/**
 * Stripe element custom classes
 */
const stripeElementClasses = {
    base: 'form-control py-2',
    complete: 'is-valid',
    invalid: 'is-invalid',
};

/** Event student id */
let eventId: any = null;
let userId: any = null;

let sponsorshipElement: HTMLElement;
let stripeFormElement: HTMLElement;
let loaderElement: HTMLElement;

// Load stripe components when the page is ready
document.addEventListener('DOMContentLoaded', () => {
    eventId = (<HTMLInputElement>document.getElementById('eventId')).value;
    userId = (<HTMLInputElement>document.getElementById('userId')).value;

    sponsorshipElement = <HTMLElement>document.getElementById('sponsorForm');
    stripeFormElement = <HTMLElement>document.getElementById('paymentForm');
    loaderElement = <HTMLElement>document.getElementById('loader');

    if (window.clientSecret) {
        // Load the stripe components
        console.log('Payment intent received');
        stripeFormElement.style.display = 'block';
        loadPaymentForm();
    } else {
        console.log('Loading sponsorship form');
        loadSponsorshipForm();
    }

    // Load the stripe components
    // loadStripeComponents();
});

const loadSponsorshipForm = async () => {
    sponsorshipElement.style.display = 'block';

    const sponsorValueElement = <HTMLInputElement>document.getElementById('sponsorValue');
    // const emailElement = <HTMLInputElement>document.getElementById('email');
    const messageElement = <HTMLInputElement>document.getElementById('message');
    const nameElement = <HTMLInputElement>document.getElementById('name');
    const continueElement = <HTMLInputElement>document.getElementById('continue');

    // Value validation
    sponsorValueElement.addEventListener('focus', event => {
        const target = <HTMLInputElement>event.target;
        target.classList.toggle('is-valid', false);
        target.classList.toggle('is-invalid', false);
    });
    sponsorValueElement.addEventListener('blur', event => {
        const target = <HTMLInputElement>event.target;
        const value = parseFloat(target.value);
        let isValid = false;

        if (target.value !== '' && value >= 5) {
            isValid = true;
        }

        sponsorValueElement.value = value.toFixed(2);

        target.classList.toggle('is-valid', isValid);
        target.classList.toggle('is-invalid', !isValid);
    });

    // // Email validation
    // emailElement.addEventListener('focus', event => {
    //     const target = <HTMLInputElement>event.target;
    //     target.classList.toggle('is-valid', false);
    //     target.classList.toggle('is-invalid', false);
    // });
    // emailElement.addEventListener('blur', event => {
    //     const target = <HTMLInputElement>event.target;
    //     let isValid = false;

    //     if (target.value !== '') {
    //         isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(target.value);
    //     }

    //     target.classList.toggle('is-valid', isValid);
    //     target.classList.toggle('is-invalid', !isValid);
    // });

    // Name validation
    nameElement.addEventListener('focus', event => {
        const target = <HTMLInputElement>event.target;
        target.classList.toggle('is-valid', false);
        target.classList.toggle('is-invalid', false);
    });
    nameElement.addEventListener('blur', event => {
        const target = <HTMLInputElement>event.target;
        let isValid = target.value.length > 0;

        target.classList.toggle('is-valid', isValid);
        target.classList.toggle('is-invalid', !isValid);
    });

    // Message validation
    messageElement.addEventListener('focus', event => {
        const target = <HTMLInputElement>event.target;
        target.classList.toggle('is-valid', false);
        target.classList.toggle('is-invalid', false);
    });
    messageElement.addEventListener('blur', event => {
        const target = <HTMLInputElement>event.target;
        let isValid = true;

        target.classList.toggle('is-valid', isValid);
        target.classList.toggle('is-invalid', !isValid);
    });

    // Continue button
    continueElement.addEventListener('click', event => {
        event.preventDefault();
        continueElement.disabled = true;

        // Validate the form
        const sponsorValue = parseFloat(sponsorValueElement.value);

        let isValid = document.querySelectorAll('.is-invalid').length === 0;

        // validate all the values again
        if (sponsorValueElement.value === '' || sponsorValue < 5) {
            isValid = false;
            sponsorValueElement.classList.toggle('is-invalid', true);
        }

        // if (emailElement.value === '' || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailElement.value)) {
        //     isValid = false;
        //     emailElement.classList.toggle('is-invalid', true);
        // }

        if (nameElement.value === '') {
            isValid = false;
            nameElement.classList.toggle('is-invalid', true);
        }

        if (!isValid) {
            continueElement.disabled = false;
            return;
        }

        const stripeLoadingPromise = loadPaymentForm(sponsorValue, nameElement.value, messageElement.value);

        // Fade out the sponsorship form, show the loader, then fade in the stripe form
        sponsorshipElement.style.transition = 'opacity 0.3s';
        sponsorshipElement.style.opacity = '0';
        setTimeout(() => {
            sponsorshipElement.style.display = 'none';

            loaderElement.style.transition = 'opacity 0.3s';
            loaderElement.style.display = 'block';
            loaderElement.style.opacity = '1';

            stripeLoadingPromise.then(() => {
                loaderElement.style.transition = 'opacity 0.3s';
                loaderElement.style.opacity = '0';
                setTimeout(() => {
                    loaderElement.style.display = 'none';

                    stripeFormElement.style.transition = 'opacity 0.3s';
                    stripeFormElement.style.display = 'block';
                    stripeFormElement.style.opacity = '1';
                }, 300);
            });
        }, 300);
    });
};

/**
 * Load all the stripe components
 */
const loadPaymentForm = async (amount: number | null = null, name: string | null = null, message: string | null = null) => {
    const returnUrl = `${window.location.origin}${window.returnUrl}`;

    let data;
    if (window.clientSecret) {
        data = {
            success: true,
            clientSecret: window.clientSecret,
            stripeAccount: window.stripeAccount,
        };
    } else {
        // Tell the backend about the sponsor to save the reference and create a payment intent
        const response = await fetch(API_ENDPOINT_CREATE_SPONSORSHIP, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                eventId,
                userId,
                amount,
                name,
                message,
            }),
        });

        if (response.status !== 200) {
            console.error('Failed to create sponsorship.');
            throw new Error('Failed to create sponsorship.');
        }

        data = await response.json();
    }

    if (data.success === undefined || !data.success) {
        console.error('Failed to retrieve stripe payment intent.');
        throw new Error('Failed to retrieve stripe payment intent.');
    }

    // load stripe
    const stripe = await loadStripe(STRIPE_PUBLIC_API_KEY, {
        stripeAccount: data.stripeAccount,
    });

    if (stripe === null) {
        console.error('Unable to load stripe');
        throw new Error('Unable to load stripe');
    }

    const sponsorValueElement = <HTMLInputElement>document.getElementById('sponsorValue');
    const messageElement = <HTMLInputElement>document.getElementById('message');
    const nameElement = <HTMLInputElement>document.getElementById('name');

    const summaryValueElement = <HTMLInputElement>document.getElementById('summaryValue');
    const summaryNameElement = <HTMLInputElement>document.getElementById('summaryName');
    const summaryMessageElement = <HTMLInputElement>document.getElementById('summaryMessage');

    const legalElement = <HTMLInputElement>document.getElementById('legal');
    const submitElement = <HTMLInputElement>document.getElementById('stripeFormSubmit');

    // Terms check
    legalElement.addEventListener('change', event => {
        submitElement.disabled = !legalElement.checked;
    });

    const appearance: Appearance = {};

    const sponsorshipId = data.sponsorshipId;
    const clientSecret = data.clientSecret;
    const elements = stripe.elements({ appearance, clientSecret });
    const paymentElement = elements.create('payment', {});
    paymentElement.mount('#payment-element');
    const linkAuthenticationElement = elements.create('linkAuthentication');
    linkAuthenticationElement.mount('#link-authentication-element');

    // Add stripe card submission listener
    const stripeForm = <HTMLInputElement>document.getElementById('stripeForm');

    const submitElementText = <HTMLInputElement>document.getElementById('stripeFormSubmitText');
    const submitElementLoading = <HTMLInputElement>document.getElementById('stripeFormSubmitLoading');

    const stripeFormErrorElement = document.getElementById('stripeFormError') as HTMLElement;

    // Get the amount from the form
    const summaryValue = sponsorValueElement.value ?? '';
    const summaryName = nameElement.value ?? '';
    const summaryMessage = messageElement.value ?? '';

    summaryValueElement.innerText = `${summaryValue}`;
    summaryNameElement.innerText = `${summaryName}`;
    summaryMessageElement.innerText = `${summaryMessage}`;

    // Re-enable the button
    submitElement.classList.toggle('disabled', false);

    // Validate card on submission
    stripeForm.addEventListener('submit', async event => {
        event.preventDefault();

        // Set spinner in card element
        submitElement.disabled = true;
        submitElementText.style.display = 'none';
        submitElementLoading.style.display = 'block';
        stripeFormErrorElement.style.display = 'none';

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                // Make sure to change this to your payment completion page
                return_url: `${returnUrl}?sponsorship_id=${sponsorshipId}`,
            },
        });

        if (error) {
            // Display error.message in your UI.
            console.error('There was an error validating with Stripe');
            console.log(error);

            submitElement.disabled = false;
            submitElementLoading.style.display = 'none';
            submitElementText.style.display = 'inline';

            stripeFormErrorElement.innerHTML = error?.message ?? 'An unknown error has occurred with your payment';
            stripeFormErrorElement.style.display = 'block';
        } else {
            // Success!
        }
    });
};
